<template>
  <div class="min-height-300 bg-primary position-absolute w-100"></div>
  <aside class="sidenav bg-white navbar navbar-vertical navbar-expand-xs border-0 border-radius-xl my-3 fixed-start ps ms-4 " id="sidenav-main">
  <!--ouverture/fermeture de la sidenav -->
  <!-- <aside class="sidenav bg-white navbar navbar-vertical navbar-expand-xs border-0 border-radius-xl my-3 fixed-start ps ms-4" :class="{ 'sidenav-closed': !sidebarOpen }" id="sidenav-main"> -->
    <div class="sidenav-header">
      <a class="navbar-brand m-0" href="#/dashboard " target="_blank">
        <img src="../assets/logo-nouveaux-convertis.jpg" class="navbar-brand-img h-100" alt="main_logo">
        <span class="ms-1 font-weight-bold">Nouveaux Convertis</span>
      </a>
    </div>
    <hr class="horizontal dark mt-0">
    <div class="collapse navbar-collapse  w-auto " id="sidenav-collapse-main">
      <ul class="navbar-nav">
        <li v-for="link in navLinks" :key="link.id" class="nav-item">
          <a class="nav-link" :href="link.url">
            <div
              class="icon icon-shape icon-sm border-radius-md text-center me-2 d-flex align-items-center justify-content-center">
              <i :class="link.iconClass"></i>
            </div>
            <span class="nav-link-text ms-1">{{ link.text }}</span>
          </a>
        </li>
      </ul>
    </div>
    <div class="sidenav-footer mx-3 ">
      <div class="card card-plain shadow-none" id="sidenavCard">
        <img class="w-50 mx-auto" src="../assets/img/illustrations/icon-documentation.svg" alt="sidebar_illustration">
        <div class="card-body text-center p-3 w-100 pt-0">
          <div class="docs-info">
            <h6 class="mb-0">Besoin d'aide?</h6>
            <p class="text-xs font-weight-bold mb-0">S'il vous plaît consulter notre documentation</p>
          </div>
        </div>
      </div>
      <button class="btn btn-icon btn-3 btn-danger btn-sm w-100 mb-3" type="button" @click="Logout">
        <i class="fa-solid fa-right-from-bracket me-sm-1"></i>
        <span class="d-sm-inline d-none">Déconnexion</span>
      </button>
      <a href="../../public/assets/fiche/FicheTechniqueUtilisateur.pdf" download
        class="btn btn-dark btn-sm w-100 mb-3">Documentation</a>
    </div>
  </aside>
</template>

<script>
import { accountService } from '@/_services';

export default {

  computed: {
    sidebarOpen() {
      return this.$store.state.sidebarOpen;
    },
  },
  data() {
    return {
      navLinks: [
        {
          id: 1,
          text: 'Tableau de Bord',
          url: '#/dashboard',
          iconClass: 'ni ni-tv-2 text-warning text-sm opacity-10'
        },
        {
          id: 2,
          text: 'Créer un Contact',
          url: '#/createcontact',
          iconClass: 'ni ni-credit-card text-success text-sm opacity-10'
        },
        {
          id: 3,
          text: 'Liste des Contacts',
          url: "#/contactlist",
          iconClass: 'ni ni-bullet-list-67 text-info text-sm opacity-10'
        },
        // {
        //     id: 4,
        //     text: 'Login',
        //     url: "#/login",
        //     iconClass: 'ni ni-single-02 text-dark text-sm opacity-10'
        // },
        // {
        //   id: 5,
        //   text: 'Tables',
        //   url: '../tables',
        //   iconClass: 'ni ni-calendar-grid-58 text-warning text-sm opacity-10'
        // },
      ],
    };
  },
  name: "SideBarComponent",

  methods: {
    async Logout() {
      try {
        await accountService.LogOut();
        //window.location.reload();

        this.redirect();


        //this.$router.push('#/da');
      } catch (error) {
        console.error("Erreur lors de la déconnexion:", error);
      }
    },
    redirect(){
      console.log('Deconnexion');
      //this.$router.push('#/da');
      this.$router.replace('#/login')
    }

    //ouverture/fermeture de la sidenav

    // toggleSidebar() {
    //   this.$store.commit('toggleSidebar');
    // },
  },

};
</script>


<style scoped>

/*//ouverture/fermeture de la sidenav*/

 .sidenav-closed {
  width: 0 !important;
}

.sidenav {
  transition: margin-left 0.3s;
}
</style>
